import { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useSession } from '@/app/providers/session-provider';
import { useTenant } from '@/tenant/tenant-provider';
import AssetImage from '../../../shared/assets/AssetImage';
import './auth.css';

export default function LoginPage() {
  const { branding } = useTenant();
  const { isAuthenticated, login, isAuthenticating, authError } = useSession();
  const [form, setForm] = useState({
    email: '',
    password: '',
  });
  const [submitError, setSubmitError] = useState('');

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  async function handleSubmit(event) {
    event.preventDefault();
    setSubmitError('');

    try {
      await login(form);
    } catch (error) {
      setSubmitError(error.message || 'Login non riuscito');
    }
  }

  return (
    <main className="auth-page">
      <section className="auth-shell" aria-label="Accesso Webtika">
        <div className="auth-logo-frame">
          <AssetImage srcKey="brand.logoHorizontal" alt={branding.appName || 'Webtika'} className="auth-logo" />
        </div>

        <div className="auth-card">
          <header className="auth-card__header">
            <p className="auth-card__eyebrow">Workspace Login</p>
            <h1 className="auth-card__title">Accedi</h1>
            <p className="auth-card__description">
              Inserisci le credenziali del tuo workspace per entrare nella piattaforma.
            </p>
          </header>

          {submitError || authError ? (
            <div className="auth-alert wt-inline-error" role="alert">
              <strong>Login non riuscito</strong>
              <span>{submitError || authError}</span>
            </div>
          ) : null}

          <form className="auth-form" onSubmit={handleSubmit}>
            <label className="auth-field" htmlFor="login-email">
              <span>Email</span>
              <input
                id="login-email"
                className="auth-input"
                type="email"
                value={form.email}
                onChange={(event) => setForm((prev) => ({ ...prev, email: event.target.value }))}
                autoComplete="email"
              />
            </label>

            <label className="auth-field" htmlFor="login-password">
              <span>Password</span>
              <input
                id="login-password"
                className="auth-input"
                type="password"
                value={form.password}
                onChange={(event) => setForm((prev) => ({ ...prev, password: event.target.value }))}
                autoComplete="current-password"
              />
            </label>

            <button type="submit" className="auth-submit" disabled={isAuthenticating}>
              {isAuthenticating ? 'Accesso in corso...' : 'Accedi'}
            </button>
          </form>

          <p className="auth-helper">Autenticazione reale via backend auth e sessione tenant.</p>
        </div>
      </section>
    </main>
  );
}
